(function ($, document, window) {
    $(function () {
        var $userLoginForm = $('#userLoginModal form');
        var $errorContainer = $userLoginForm.find('.error');


        $userLoginForm.on('submit', function (e) {
            e.preventDefault();
            $errorContainer.hide();

            var dataString = $(this).serialize();
            var ajaxUrl = $userLoginForm.data('ajax-target');
            $.ajax({
                type: 'POST',
                url: ajaxUrl,
                data: dataString,
                success: function (res) {
                    console.log(typeof res.success);
                    if (res.success) {
                        if (res.location) {
                            window.location.href = res.location;
                        }
                        else {
                            window.location.reload();
                        }
                    } else {
                        $errorContainer.html(res.errormessage);
                        $errorContainer.show();
                    }

                },
                error: function (res, statusText, errorThrown) {
                    $errorContainer.html(errorThrown);
                    $errorContainer.show();
                }
            });

            return false;

        });

        $('#forgotPasswordModalForm').on('submit', function (e) {

            var dataString = $(this).serialize();

            $.ajax({
                type: 'POST',
                url: $(this).attr('action'),
                data: dataString,
                success: function (res) {
                    $('.emailsent').show();

                }
            });

            e.preventDefault();
        });
        $('#registerAccountModalForm').on('submit', function (e) {

            var dataString = $(this).serialize();

            $.ajax({
                type: 'POST',
                url: $(this).attr('action'),
                data: dataString,
                success: function (res) {

                    if (res === 'success') {
                        $('#userregistered').show();
                        $('#registeraccounterrors').hide();
                    }
                    else {
                        var tag = '<span class="field-validation-error">' + res + '</span>';

                        $('#registeraccounterrors').html(tag);
                        $('#registeraccounterrors').show();


                    }

                }
            });

            e.preventDefault();
        });


    });
}(jQuery, document, window));